import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { TeachingBubble, DirectionalHint } from 'office-ui-fabric-react';
var NavTeachingBubbleBase = /** @class */ (function (_super) {
    __extends(NavTeachingBubbleBase, _super);
    function NavTeachingBubbleBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavTeachingBubbleBase.prototype.render = function () {
        var _a = this.props, calloutProps = _a.calloutProps, teachingBubbleProps = __rest(_a, ["calloutProps"]);
        return (React.createElement(TeachingBubble, __assign({ hasCondensedHeadline: true, hasSmallHeadline: true, hasCloseIcon: true, isWide: false }, teachingBubbleProps, { calloutProps: __assign({ beakWidth: 12, directionalHint: DirectionalHint.bottomLeftEdge, directionalHintFixed: true }, calloutProps) })));
    };
    return NavTeachingBubbleBase;
}(React.Component));
export { NavTeachingBubbleBase };
//# sourceMappingURL=NavTeachingBubbleBase.js.map